import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cotizacionClearActive, cotizacionesStartLoad } from "../../../actions";
import { CotizacionScreen } from "./CotizacionScreen";
import { CotizacionSearchList } from "./CotizacionSearchList";
import { CotizacionTable } from "./CotizacionTable";
import { PageHeaderUi } from "../../ui/PageHeaderUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { ButtonUi } from "../../ui/ButtonUi";

const CotizacionListScreen = ({ handleOpenForm }) => {
  const dispatch = useDispatch();
  const { cotizaciones, loading, paginator } = useSelector(
    (state) => state.cotizacion,
  );
  const handleLoadCotizacion = () => {
    dispatch(cotizacionesStartLoad({}));
  };
  return (
    <>
      <PageHeaderUi
        title="Cotizaciones"
        subTitle="Listado"
        extra={[
          <ButtonUi
            key="actualizar"
            typeUi={TipoButtonConstants.Actualizar}
            onClick={handleLoadCotizacion}
          />,
          <ButtonUi
            key="nuevo"
            typeUi={TipoButtonConstants.Nuevo}
            onClick={handleOpenForm}
          />,
        ]}
      >
        <div style={{ overflow: "hidden" }}>
          <CotizacionSearchList />
          <Row>
            <Col sm={32} md={32} xl={24}>
              <CotizacionTable
                cotizaciones={cotizaciones}
                loading={loading}
                paginator={paginator}
                handleOpenForm={handleOpenForm}
              />
            </Col>
          </Row>
        </div>
      </PageHeaderUi>
    </>
  );
};

export const CotizacionList = () => {
  const dispatch = useDispatch();
  const [openForm, setOpenForm] = useState(false);
  const handleOpenForm = () => setOpenForm(true);
  const handleCloseForm = () => {
    dispatch(cotizacionClearActive());
    setOpenForm(false);
  };
  useEffect(() => {
    dispatch(cotizacionesStartLoad({}));
  }, []);
  if (openForm) {
    return <CotizacionScreen handleCloseForm={handleCloseForm} />;
  } else {
    return <CotizacionListScreen handleOpenForm={handleOpenForm} />;
  }
};
export default CotizacionList;
